import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';

export const usePdpSellerReviewsVariant = (): boolean => {
    const { isPdpSellerReviewsVariant } = useServerVarsContext();
    return !!isPdpSellerReviewsVariant;
};
